/* cspell:disable-next-line */
export const BASE_URL = `${process.env.REACT_APP_BASE_URL ?? ''}`;
export const APP_VERSION = '0.1.1596-alpha';

export const SITE_URLS = {
    // authentication routes
    createAccount: 'register',
    login: 'login',
    recoverPassword: 'recover-password',
    setNewPassword: 'new-password',
    twoFactorAuthActivate: 'activate-2fa',
    twoFactorAuthVerify: 'verify-2fa',
    // marketplace routes
    home: '',
    products: 'products',
    productsSearch: 'products/search/:searchQuery',
    productsSubcategory: 'products/category/:categoryUuid',
    productDetail: 'product/:uuid',
    services: 'services',
    servicesSearch: 'services/search/:searchQuery',
    merchants: 'merchants',
    merchantsSearch: 'merchants/?text=:searchQuery',
    merchantDetail: 'merchant/:uuid',
    promoBaskets: 'baskets',
    promoBasketDetail: 'basket/:uuid',
    campaigns: 'campaigns',
    contacts: 'contacts',
    howToUsePoints: 'points/how-to-use',
    pointsServices: 'points/services',
    pointsServiceDetail: 'points/service/:uuid',
    policy: 'policy/:pageKey',
    // shopping cart pages
    shoppingCart: 'shopping-cart',
    orderBilling: 'shopping-cart/billing',
    orderDeliveryAddress: 'shopping-cart/delivery-address',
    orderPayment: 'shopping-cart/payment',
    orderConfirm: 'shopping-cart/confirm-order',
    orderFeedback: 'shopping-cart/feedback',
    cardPaymentRedirect: 'shopping-cart/card-payment-redirect',
    // service cart pages
    servicesCart: 'services-cart/:serviceUuid',
    servicesBookingEmployees: 'services-cart/employees',
    servicesBookingScheduling: 'services-cart/scheduling',
    servicesBookingPayment: 'services-cart/payment',
    servicesBookingConfirm: 'services-cart/confirm',
    servicesPreBookingFeedback: 'services-cart/pre-booking-feedback',
    servicesBookingFeedback: 'services-cart/booking-feedback',
    // my account pages
    myDashboard: 'my-account/dashboard',
    myProfile: 'my-account/my-profile',
    myOrders: 'my-account/my-orders',
    myOrderDetail: 'my-account/my-order/:uuid',
    myProductReservations: 'my-account/my-product-reservations',
    myProductReservationDetail: 'my-account/my-product-reservation/:uuid',
    complaint: 'my-account/complaint/:uuid',
    myCompanies: 'my-account/my-companies',
    myCompaniesCreate: 'my-account/create-company',
    myCompaniesEdit: 'my-account/my-company/:uuid',
    myAdherences: 'my-account/my-adherences',
    myAdherenceDetail: 'my-account/my-adherences/:uuid',
    myCoupons: 'my-account/my-coupons',
    myCouponsCreate: 'my-account/create-coupon',
    myCouponsEdit: 'my-account/my-coupon/:uuid',
    myProducts: 'my-account/products',
    myServices: 'my-account/services',
    myWorkers: 'my-account/workers/:store',
    mySchedule: 'my-account/schedule/:uuid',
    myProductsEdit: 'my-account/edit-product/:uuid',
    myProductsCreate: 'my-account/create-product',
    myWorkersCreate: 'my-account/create-worker/:store',
    myWorkersEdit: 'my-account/edit-worker/:uuid',
    myServicesCreate: 'my-account/create-service',
    myServicesEdit: 'my-account/edit-service/:uuid',
    manageOrders: 'my-account/manage-orders',
    manageOrderDetail: 'my-account/manage-order/:order_uuid/:store_uuid',
    manageProductReservations: 'my-account/manage-product-reservations',
    manageProductReservationDetail: 'my-account/manage-product-reservation/:uuid',
    myPoints: 'my-account/history',
    myAddresses: 'my-account/addresses',
    myAddressesCreate: 'my-addresses/create',
    myAddressesEdit: 'my-addresses/edit/:uuid',
    pageNotFound: 'notfound',
};

export const PASSWORD_MIN_LENGTH = 8;
export const REGEX_HAS_UPPERCASE = /[A-Z]/;
export const REGEX_HAS_LOWERCASE = /[a-z]/;
export const REGEX_HAS_DIGIT = /\d/;
export const REGEX_HAS_SPECIAL_CHAR = /\W/;
export const REGEX_IS_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const NOTIFICATIONS_DISMISS_SECONDS = 5;

// local storage keys
export const SERVICES_CART_KEY = 'services-cart';
export const SERVICES_CART_STORE_KEY = 'services-cart-store';
export const SERVICES_CART_STORE_NAME_KEY = 'services-cart-store-name';
export const SERVICES_CART_SCHEDULE_TYPE_KEY = 'services-cart-schedule-type';
export const SERVICES_CART_DISPLAY_WORKERS_KEY = 'services-cart-display-workers';
export const SERVICES_CART_WORKER_KEY = 'services-cart-worker';
export const SERVICES_CART_SCHEDULE_DAY_KEY = 'services-cart-schedule-day';
export const SERVICES_CART_SCHEDULE_TIME_KEY = 'services-cart-time';
export const SERVICES_CART_OBSERVATIONS_KEY = 'services-cart-observations';
export const SERVICES_CART_PAYMENT_METHOD_KEY = 'services-cart-payment-method';
export const SERVICES_CART_PAYMENT_PHONE_NUMBER_KEY = 'services-cart-payment-phone-number';
export const GRAYSCALE_THEME_KEY = 'use-grayscale';
export const BASE_FONT_SIZE_KEY = 'base-font-size';
export const OVER_18_KEY = 'over-18';

export const DEFAULT_BASE_FONT_SIZE_PX = 16;
export const BASE_FONT_SIZE_STEPS_PX = [12, 13, 14, 15, 16, 18, 20, 24, 26];

export const API_VERSION = '/api/v1';
export const API_URL = `${process.env.REACT_APP_API_URL ?? ''}${API_VERSION}`;
